import SyncWithElapsedTimeStrategy from './SyncWithElapsedTimeStrategy';

export default SyncWithElapsedTimeStrategy;
